import { render, staticRenderFns } from "./AddSnapchatForm.vue?vue&type=template&id=774636e4&scoped=true&"
import script from "./AddSnapchatForm.vue?vue&type=script&lang=js&"
export * from "./AddSnapchatForm.vue?vue&type=script&lang=js&"
import style0 from "./AddSnapchatForm.vue?vue&type=style&index=0&id=774636e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774636e4",
  null
  
)

export default component.exports